// extracted by mini-css-extract-plugin
export default {"confete":"Confete_confete__Spzl8"};